import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgZorroAntdModule } from "ng-zorro-antd";
import { HdAccessoryListComponent } from "./hd-accessory-list.component";

@NgModule({
  imports: [CommonModule, NgZorroAntdModule],
  declarations: [HdAccessoryListComponent],
  exports: [HdAccessoryListComponent],
})
export class HdAccessoryListModule {}
